function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.0725098,
  width: 58.657,
  height: 57,
  rx: 8,
  fill: "#87C5FF",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.918 22.5335C26.918 21.3787 27.8854 20.9346 29.4877 20.9346C31.7853 20.9346 34.6875 21.6156 36.985 22.8296V15.8712C34.4758 14.894 31.9969 14.5091 29.4877 14.5091C23.3507 14.5091 19.2695 17.6478 19.2695 22.8888C19.2695 31.0613 30.7574 29.7584 30.7574 33.2821C30.7574 34.6442 29.5481 35.0883 27.8552 35.0883C25.346 35.0883 22.1415 34.0816 19.6021 32.7195V39.7668C22.4136 40.9512 25.2553 41.4546 27.8552 41.4546C34.1433 41.4546 38.4664 38.4047 38.4664 33.1044C38.4361 24.2805 26.918 25.8499 26.918 22.5335Z",
  fill: "white"
});

function SvgTotal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 57,
    viewBox: "0 0 59 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.e9759bcd.svg";
export { ForwardRef as ReactComponent };